import { RedirectPaths, RedirectPathsEnum } from '@/common/constants';
import { OWN_MATERIALS_BOOK_DEMO } from '@/common/constants/external-urls';
import { InfoCard } from '@/components/free-trial-onboarding';
import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import { OwnMaterialsBookIcon, OwnMaterialsCreateIcon } from '@/utils/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledContainer = styled(FlexContainer)`
  width: 100%;
  background-color: var(--beige-main);
  border-radius: var(--medium-border-radius);
  padding: var(--big-padding);

  .card-wrapper {
    z-index: 1;
    align-items: stretch;
    margin-top: var(--medium-padding);
  }

  h2 {
    font-size: var(--heading-medium-font-size);
    line-height: var(--heading-medium-line-height);
    font-weight: 700;
    text-align: center;
    margin-bottom: var(--small-padding);
  }

  .subtitle {
    text-align: center;
    line-height: var(--medium-line-height);
    font-weight: 500;
    text-align: center;
    margin-bottom: var(--big-padding);
  }
`;

export const OwnMaterialsDemo: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <StyledContainer direction="column" flex="1">
      <h2>{t('materials.demo.title')}</h2>
      <p className="subtitle">{t('materials.demo.subtitle')}</p>
      <FlexContainer gap={21} className="card-wrapper">
        <InfoCard
          icon={<OwnMaterialsCreateIcon />}
          title={t('materials.demo.upload.title')}
          description={t('materials.demo.upload.description')}
          features={[
            t('materials.demo.upload.feature1'),
            t('materials.demo.upload.feature2'),
            t('materials.demo.upload.feature3'),
          ]}
          actionText={t('materials.demo.upload.action')}
          onClick={() =>
            navigate(RedirectPaths[RedirectPathsEnum.CUSTOM_MATERIALS_CREATE]())
          }
          className="custom-materials"
        />
        <InfoCard
          icon={<OwnMaterialsBookIcon />}
          title={t('materials.demo.guide.title')}
          description={t('materials.demo.guide.description')}
          features={[
            t('materials.demo.guide.feature1'),
            t('materials.demo.guide.feature2'),
            t('materials.demo.guide.feature3'),
          ]}
          action={
            <a
              href={OWN_MATERIALS_BOOK_DEMO}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              <AppButton label={t('materials.demo.guide.action')} />
            </a>
          }
          className="custom-materials"
        />
      </FlexContainer>
    </StyledContainer>
  );
};
